import { useMediaQuery } from '@mui/material';
import { useCapabilities } from '../../demo/capabilities';

export const COMPACT_UI_QUERY = '(max-width: 1100px), (max-height: 700px)';

export const useCompactUI = (): boolean => {
    const { allowCompactUI } = useCapabilities();
    const isSmallViewport = useMediaQuery(COMPACT_UI_QUERY);

    return allowCompactUI && isSmallViewport;
};
